/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Body for the render endpoint: applied control selections + optional time range.
 * @export
 * @interface DashboardRenderRequest
 */
export interface DashboardRenderRequest {
    /**
     * Applied selections keyed by control key, the instance picker included: the install_base_id-dimension control carries the instance scope. An empty or absent selection means every accessible instance.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DashboardRenderRequest
     */
    selections?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof DashboardRenderRequest
     */
    timeRange?: string | null;
}

/**
 * Check if a given object implements the DashboardRenderRequest interface.
 */
export function instanceOfDashboardRenderRequest(value: object): value is DashboardRenderRequest {
    return true;
}

export function DashboardRenderRequestFromJSON(json: any): DashboardRenderRequest {
    return DashboardRenderRequestFromJSONTyped(json, false);
}

export function DashboardRenderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardRenderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': json['selections'] == null ? undefined : json['selections'],
        'timeRange': json['time_range'] == null ? undefined : json['time_range'],
    };
}

export function DashboardRenderRequestToJSON(json: any): DashboardRenderRequest {
    return DashboardRenderRequestToJSONTyped(json, false);
}

export function DashboardRenderRequestToJSONTyped(value?: DashboardRenderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': value['selections'],
        'time_range': value['timeRange'],
    };
}

